import React from "react";
import { useAppSelector } from "../../../redux/store";
import { useTranslation } from "react-i18next";

const TravelPeriod = () => {
  const { t } = useTranslation();
  const booking = useAppSelector((state) => state.booking);
  const travelPeriod = booking.bookingDetails.travelPeriod;

  return (
    <>
      <p>
        <strong>{t("bookingDetails.overview.travelPeriod")}: </strong>
      </p>
      <p>{travelPeriod}</p>
    </>
  );
};

export default TravelPeriod;
